import { BrowserModule, Title } from '@angular/platform-browser';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { APP_INITIALIZER, Injectable, NgModule } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HttpHeaders, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DefaultUrlSerializer, Router, UrlSerializer, UrlTree } from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { AppRoutingModule } from './app-routing.module';
import { ShopModule } from './components/shop/shop.module';
import { SharedModule } from './components/shared/shared.module';
import { ColorOptionsComponent } from './components/color-options/color-options.component';
import { NotTranslatedService } from './components/shared/services/not-ranslated.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MyLoaderComponent } from './components/my-loader/my-loader.component';
import { LoaderService } from './components/shared/services/loader.service';
import { LoaderInterceptor } from './components/shared/services/interceptors/loader-interceptor.service';
import { ConfigService } from './components/shared/services/config.service';
import { environment } from 'src/environments/environment';
import { CommonSetting } from './modals/commonsetting.modal';
import { PagesModule } from './components/pages/pages.module';
import { FindEnrollerComponent } from './components/shared/model/findenroller/findenroller.component';
import { PersistentService } from './components/shared/services/persistent.service';
import { ApiInterceptor } from './components/shared/services/interceptors/http-interceptor.service';
import { CookieService } from 'ngx-cookie-service';
import { getSubdomain } from 'tldts';
import { AuthGuard } from './components/shared/services/auth.guard.service';
import { LoggedInAuthGuard } from './components/shared/services/loggedin.guard.service';
import { APP_BASE_HREF } from '@angular/common';
import { getBaseLocation } from './baseUrl';
import { UserServiceModal } from './modals/userservice.modal';
const initializeConfig = (configService: ConfigService, http: HttpClient, dailog: MatDialog, translate) => {
  const promise2 = new Promise((resolve, reject) => {
    let subdomain = getBaseLocation();
    if (!subdomain) {
      subdomain = configService.DefaultWebalias;
    } else {
      subdomain = subdomain.replace('/', '');
      // Ensure we have a valid webAlias, fallback to default if empty
      if (!subdomain || subdomain === '') {
        subdomain = configService.DefaultWebalias;
      }
    }
    http.get(`${environment.apiUrl}api/Customers/GetWebsiteInformation_V1?webAlias=${subdomain}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      }),
      // withCredentials: true
    }).toPromise()
      .then((result: any) => {
        if (!result.Data) {
          //webalias not found so setting default to www making call below
          http.get(`${environment.apiUrl}api/Customers/GetWebsiteInformation_V1?webAlias=${configService.DefaultWebalias}`, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8'
            }),
            // withCredentials: true
          }).toPromise().then((result: any) => {
            //update url
            subdomain = configService.DefaultWebalias
            // Handle the case where we're at root path
            const pathSegments = window.location.pathname.split('/');
            const currentWebAlias = pathSegments[1] || '';
            const afterPath = pathSegments[2] || '';
            
            // Check if we're already at the correct webalias path
            if (currentWebAlias === subdomain) {
              // Already at correct webalias, don't redirect
              return;
            }
            
            if (currentWebAlias && afterPath) {
              // We have both webAlias and after path, replace the webAlias
              const newPath = window.location.pathname.replace('/' + currentWebAlias, '/' + subdomain);
              window.location.href = location.origin + newPath;
            } else if (currentWebAlias && !afterPath) {
              // We have webAlias but no after path, redirect to home
              window.location.href = location.origin + '/' + subdomain + '/home';
            } else {
              // We're at root, redirect to default webAlias with home
              window.location.href = location.origin + '/' + subdomain + '/home';
            }
            configService.setWebsiteInfo(result.Data);

            //localconfig file get call
            http.get<any>(`assets/data/localconfig.json`, {
              headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=utf-8'
              })
            }).subscribe((data) => {
              configService.localSettings = data;
              return resolve(result.Data);
            });
            //localconfig file get call ends
          })
          //default webalias call ends
          //else block for found webalias and empty webalias also
        } else {
          configService.setWebsiteInfo(result.Data);

          //localconfig file get call
          http.get<any>(`assets/data/localconfig.json`, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8'
            })
          }).subscribe((data) => {
            configService.localSettings = data;
            return resolve(result.Data);
          });
          //localconfig file get call ends
        }
      }).catch((error) => {
        // If the first API call fails, try with default webAlias
        
        // If it's a 500 error, use fallback data for development
        if (error.status === 500) {
          const fallbackData = {
            Status: 0,
            Data: {
              WebAlias: "www",
              CompanyName: "TangerineFun",
              CustomerId: 1,
              FirstName: "Default",
              LastName: "User",
              EmailAddress: "default@tangerinefun.com",
              PrimaryPhone: "",
              SecondaryPhone: "",
              City: "",
              Region: "",
              CountryCode: "US",
              AboutMe: "",
              EnrollmentUrl: "",
              OfficeUrl: "",
              ShoppingLink: "",
              Facebook: "",
              Twitter: "",
              Pinterest: "",
              YouTube: "",
              Linkdin: "",
              ImageUrl: "",
              BackOfficeId: "",
              ReplicatedSiteUrl: "",
              LanguageCode: "en",
              CustomerType: "Customer"
            }
          };
          
          configService.setWebsiteInfo(fallbackData.Data);
          //localconfig file get call
          http.get<any>(`assets/data/localconfig.json`, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8'
            })
          }).subscribe((data) => {
            configService.localSettings = data;
            return resolve(fallbackData.Data);
          });
          return;
        }
        
        http.get(`${environment.apiUrl}api/Customers/GetWebsiteInformation_V1?webAlias=${configService.DefaultWebalias}`, {
          headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
          }),
          // withCredentials: true
        }).toPromise().then((result: any) => {
          configService.setWebsiteInfo(result.Data);
          //localconfig file get call
          http.get<any>(`assets/data/localconfig.json`, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8'
            })
          }).subscribe((data) => {
            configService.localSettings = data;
            return resolve(result.Data);
          });
        }).catch((defaultError) => {
          console.error('Default webAlias API call also failed:', defaultError);
          reject(defaultError);
        });
      }).finally(() => {
      });
  });
  const promise1 = new Promise((resolve, reject) => {
    http.get(`assets/data/clientsetting.json`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8'
        }),
        withCredentials: true
      }).toPromise()
      .then((result: CommonSetting) => {
        // Wait for configService.init() (which fetches allowedCountries
        // and seeds selectedCountry) before resolving — otherwise
        // HeaderComponent.ngOnInit can race ahead and read
        // allowedCountries while it's still undefined.
        return configService.init(result)
          .catch((err) => {
            console.error('ConfigService.init failed:', err);
            // Seed a safe default so downstream consumers don't crash.
            if (!configService.allowedCountries) {
              configService.allowedCountries = { Data: [] };
            }
          })
          .then(() => resolve(result));
      }).finally(() => {
      });
  });
const promise3 = new Promise((resolve, reject) => {
    http.get<any>(`assets/data/localconfig.json`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    }).subscribe((data) => {
      configService.localSettings = data;
      return resolve(data);
    });
  });

  return async () => {
    const res = await Promise.all([promise2, promise1, promise3]);
    return res;
  };
};

@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): any {
    if (params.interpolateParams) {
      return params.interpolateParams['Default'] || params.key;
    }
    return params.key;
  }

  constructor(private nts: NotTranslatedService) { }
}

@Injectable()
// export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
//   parse(url: string): UrlTree {
//     return super.parse(url.toLowerCase());
//   }
// }
@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    ColorOptionsComponent,
    MyLoaderComponent
  ],
  imports: [
    NgxSpinnerModule,
    BrowserModule,
    NgbModule,
    SharedModule,
    ShopModule,
    PagesModule,
    NgbModule,
    NgbCarouselModule,
    NgxSkeletonLoaderModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgxImageZoomModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
        deps: [NotTranslatedService]
      }
    })
  ],
  providers: [

    UserServiceModal,
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseLocation
    },
    ConfigService,
    { provide: APP_INITIALIZER, useFactory: initializeConfig, deps: [ConfigService, HttpClient, MatDialog], multi: true },
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    Title,
    PersistentService,
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: function (router: Router, cookieService: CookieService) {
        return new ApiInterceptor(router, cookieService);
      },
      multi: true,
      deps: [Router, CookieService]
    },
    AuthGuard,
    LoggedInAuthGuard
  ],
  exports: [
    MatDialogModule
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}